import { BROADBAND_RECHARGE_ROUTE } from "../../../../app/routes/routeConstant";

export const ENDPOINTS = {
  LINE_TYPE_URL: "/subscriber/line-type",
  FETCH_POSTPAID_BILL: "/subscriber/v1/bill",
  GET_BUNDLE_URL: "/product/v1/bundle",
  GET_DEVICE_DETAIL: "/subscriber/v1/get-device-details",
  VALIDATE_ACCOUNT: "/subscriber/validate/msisdn-account",
  RECHARGE_BUNDLE_URL: "/product/v4/bundle",
  SEND_OTP_V3: "/otp/v3/send-otp",
  RESEND_OTP_V3: "/otp/v3/resend-otp",
  VERIFY_OTP_V3: "/otp/v3/verify-otp",
  PROFILE_AND_BALANCE: "/subscriber/v1/profile-and-balance",
  CHECK_BROADBAND_AND_LINKED_DEVICE: "/api/portal-service/subscriber/v1/check-broadband-and-linked-device"
};
export const RECHARGE_TYPE = {
  PREPAID_RECHARGE: "PREPAID RECHARGE",
  POSTPAID_BILL_PAY: "POSTPAID BILL PAYMENT",
  DATA_BUNDLE_PURCHASE: "BUNDLE PURCHASE",
  AIRTEL_TV_RECHARGE: "AirtelTV",
  BROADBAND_RECHARGE: "Broadband Recharge",
  BILL_PAYMENT: "BILL_PAYMENT",
  HYBRID_POSTPAID_CHECK: "HYBRID_POSTPAID_CHECK",
  USER_AND_DEVICE_IDENTIFICATION: "USER_AND_DEVICE_IDENTIFICATION"
};

export const MSG = "msg";
export const POSTPAID = "POSTPAID";
export const PREPAID = "PREPAID";
export const HYBRID = "HYBRID";
export const ORP = "orp";
export const PREPAID_BUNDLE_PURCHASE = "PREPAID_BUNDLE_PURCHASE";
export const POSTPAID_BUNDLE_PURCHASE = "POSTPAID_BUNDLE_PURCHASE";

export const POSTAPID_BREDBCUMB_ROUTE = [
  { label: "Home", path: "/" },
  { label: "Bundle & Top-up", path: "/" },
  { label: "Postpaid", path: "/new-postpaid" },
];

export const PREPAID_BREDBCUMB_ROUTE = [
  { label: "Home", path: "/" },
  { label: "Bundle & Top-up", path: "/" },
  { label: "Prepaid", path: "/new-prepaid" },
];

export const BUY_BUNDLE_BREDBCUMB_ROUTE = [
  { label: "Home", path: "/" },
  { label: "Bundle & Top-up", path: "/" },
  { label: "Buy Bundle", path: "/buy-bundle" },
];

export const THEME_V1 = "theme-v1";
export const AIRTIME_RECHARGE = "AIRTIME_RECHARGE";
export const POSTPAID_BILL = "POSTPAID_BILL";
export const RECHARGE_AMOUNT = "Recharge Amount";
export const STATUS_CODE_SUCCESS = 200;
export const POSTPAID_ROUTE = "v2/postpaid-bill-pay";
export const PREPAID_ROUTE = "v2/prepaid-recharge"
export const ORPCONFIG = "ORPCONFIG";
export const TRUE = "true";
export const UNLIMITED = "Unlimited";
export const OTHERS = "Others";
export const VALIDITY = "validity";
export const GET_LINKED_DETAILS = "GET_LINKED_DETAILS";
export const HBB_RECHARGE = "HBB_RECHARGE";
export const PREPAID_BUNDLES = "PREPAID_BUNDLES";
export const POSTPAID_BUNDLES = "POSTPAID_BUNDLES";
export const PREPAID_RECHARGE = "PREPAID_RECHARGE"
export const PRE = "Prepaid"
export const AMOUNT = "amount"
export const ROUTER = "ROUTER"
export const ICONS = "icons";
export const RECHARGE_AND_BILL = "recharge and bill"
export const DATA = "data"
export const POSTPAID_RECHARGE = "POSTPAID RECHARGE"
export const INVOICE = "INVOICE"
export const FETCH_BILL_DETAILS = "FETCH_BILL_DETAILS";



export const OUTSTANDING_AMOUNT_MSG = "OUTSTANDING_AMOUNT_MSG";
export const POSTPAID_MAKE_PAYMENT = "POSTPAID_MAKE_PAYMENT";
export const INVALID_MOBILE_NO = "INVALID_MOBILE_NO";
export const INVALID_USER = "INVALID_USER";
// fallback until INVALID_USER is added to ui-translations
export const INVALID_USER_TEXT = "Invalid User";
export const MSISDN_WARNING_ICON = "msisdn_warning_icn.svg";
export const OTP = "OTP";
export const RESEND_TEXT = "RESEND_TEXT";
export const OTP_NOT_RECIEVE_TEXT = "OTP_NOT_RECIEVE_TEXT";
export const HEADING = "HEADING";
export const SUBTEXT = "SUBTEXT";
export const CODE_EXPIRE_TEXT = "CODE_EXPIRE_TEXT";
export const CURRENT_TIME = "CURRENT_TIME";
export const OTP_LENGTH_TEXT = "OTP_LENGTH_TEXT";
export const TOTAL_OUTSTANDING = "TOTAL_OUTSTANDING";

export const ORP_MIN_AMOUNT_ERROR = "ORP_MIN_AMOUNT_ERROR";
export const ORP_MAX_AMOUNT_ERROR = "ORP_MAX_AMOUNT_ERROR";

export const BUY_PLANS_FOR_OTHER_LINES = "BUY_PLANS_FOR_OTHER_LINES";
export const AUTHENTICATE_NOW = "AUTHENTICATE_NOW";
export const BUY_AIRTIME = "BUY_AIRTIME";
export const RECHARGE_AND_PAY_BILLS = "RECHARGE_AND_PAY_BILLS";
export const PLEASE_ENTER_PREPAID_POSTPAID_FIXED_INTERNET_VALUE =
  "PLEASE_ENTER_PREPAID_POSTPAID_FIXED_INTERNET_VALUE";
export const PROCEED = "PROCEED";
export const MAKE_PAYMENT = "MAKE_PAYMENT";
export const LINKED_DEVICE_HEADING = "LINKED_DEVICE_HEADING";
export const LINKED_DEVICE_SUB_HEADING = "LINKED_DEVICE_SUB_HEADING";
export const USER = "USER";
export const REWARDS = "REWARDS";
export const REWARDS_HEADING = "REWARDS_HEADING"

export const POSTPAID_BILL_PAYMENT = "POSTPAID_BILL_PAYMENT";
export const GET_YOUR_PAYMENT_DONE = "GET_YOUR_PAYMENT_DONE";
export const BUY_AIRTIME_HEADING = "BUY_AIRTIME_HEADING";
export const BUY_BUNDLE_HEADING = "BUY_BUNDLE_HEADING"
export const MOBILE_NUMBER = "MOBILE_NUMBER";
export const ENTER_AMOUNT = "ENTER_AMOUNT";
export const FOUND_MULTIPLE_DEVICES_LINE_TYPE = "FOUND_MULTIPLE_DEVICES_LINE_TYPE";

export const PREPAID_TITLE = "Prepaid";
export const BUY_NOW = "BUY_NOW";
export const ALL = "ALL";
export const FETCH_BILL = "FETCH_BILL";

export const CONVERTED_VALUE_MSG = "CONVERTED_VALUE_MSG";
export const OUTSTANDING_AMOUNT = "OUTSTANDING_AMOUNT";

export const ACCOUNT_NO="ACCOUNT_NO"
export const GET_OUTSTANDING="GET_OUTSTANDING"
export const FETCH_VIA_ACCOUNT_NO="FETCH_VIA_ACCOUNT_NO"

export const BACK="BACK"
export const SEE_LESS ="SEE_LESS"
export const SEE_MORE ="SEE_MORE"
export const SEE_LESS_DETAILS ="SEE_LESS_DETAILS"
export const SEE_MORE_DETAILS ="SEE_MORE_DETAILS"
export const ATTEMPTS_LEFT="ATTEMPTS_LEFT"


export const BROADBAND_BREDBCUMB_ROUTE = [
  { label: "Home", path: "/" },
  { label: "Bundle", path: "/" },
  { label: "Broadband", path: BROADBAND_RECHARGE_ROUTE },
];

export const EN_GB = "en-GB";
export const OTP_VERIFICATION_EXHAUSTED_ERROR_MSG = "OTP_VERIFICATION_EXHAUSTED_ERROR_MSG";
export const HBB = "HBB";
export const NAME = 'name';
export const Mifi = "Mifi";